/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/trange.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'Filters data for the given time range using the @timestamp attribute.',
  examples: [
    'FROM k8s\n| WHERE TRANGE(1h)\n| KEEP @timestamp',
    'FROM k8s\n| WHERE TRANGE("2024-05-10T00:17:14.000Z", "2024-05-10T00:18:33.000Z")\n| SORT @timestamp\n| KEEP @timestamp\n| LIMIT 10',
    'FROM k8s\n| WHERE TRANGE(to_datetime("2024-05-10T00:17:14Z"), to_datetime("2024-05-10T00:18:33Z"))\n| SORT @timestamp\n| KEEP @timestamp\n| LIMIT 10',
    'FROM k8s\n| WHERE TRANGE(to_datetime("2024-05-10T00:17:14.000Z"), to_datetime("2024-05-10T00:18:33.000Z"))\n| SORT @timestamp\n| KEEP @timestamp\n| LIMIT 10',
    'FROM k8s\n| WHERE TRANGE(1715300236000, 1715300282000)\n| SORT @timestamp\n| KEEP @timestamp\n| LIMIT 10',
  ],
  params: {
    start_time_or_offset: ' Offset from NOW for the single parameter mode. Start time for two parameter mode.  In two parameter mode, the start time value can be a date string, date, date_nanos or epoch milliseconds. ',
    end_time: 'Explicit end time that can be a date string, date, date_nanos or epoch milliseconds.',
  },
};

export default docs;
